import { EscortState } from './types';
import { RootState } from 'store/reducer';

export const escortsState = (state: RootState): EscortState => state.escorts;
